module.exports = __webpack_public_path__ + "static/media/inetcpl_1315.2ab1075e.ico";